/**
 * Portuguese Contact Translations
 * 联系页翻译模块 - 葡萄牙语
 * 
 * 包含联系表单、联系信息、地图等翻译
 */

import type { ContactTranslations } from '../../types';

export const ptContact: ContactTranslations = {
  title: 'Contate-nos',
  subtitle: 'Gostaríamos de ouvir você.',
  header: {
    title: 'Contate-nos',
    subtitle: 'Gostaríamos de ouvir você.',
  },
  form: {
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'Endereço de E-mail',
    interested: 'Produto de Interesse',
    selectProduct: 'Selecione',
    message: 'Mensagem',
    send: 'Enviar Mensagem',
    sending: 'Enviando...',
  },
  info: {
    headquarters: 'Sede',
    address: 'Edifício 25, Parque de Ciência e Tecnologia Wanyang, 26 Rua Tingjiang, Distrito de Tingjiang, Distrito de Mawei, Fuzhou, Fujian, China',
    phoneSupport: 'Suporte Telefônico',
    phone: '+86-15080458735',
    phoneHours: 'Seg-Sex 9h - 18h (GMT+8)',
    emailUs: 'Escriva-nos',
    sales: 's3@jinghui-tech.com',
    support: 's3@jinghui-tech.com',
    distributor: 'Rede de Distribuidores',
    distributorDesc: 'Estamos procurando distribuidores globais. Junte-se a nós para trazer aquecimento verde ao seu país.',
  },
  success: {
    title: 'Mensagem Enviada!',
    desc: 'Obrigado por nos contatar. Nossa equipe de vendas responderá dentro de 24 horas.',
    sendAnother: 'Enviar outra mensagem',
  },
};
